// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";

import AgentSocial from "../../../agent-detail/AgentSocial";
import BrokerInfo from "../compliance/BrokerInfo";
import BrokerUrl from "../compliance/BrokerUrl";
import get from "lodash/get";
import find from "lodash/find";
import type {
  $SiteOffice,
  $Site,
  ComplianceItems,
  $SiteOfficeBroker,
} from "flow/types";

type $Props = {
  classes: Object,
  office: $SiteOffice,
  site: $Site,
  compliance: ComplianceItems,
  brokers?: $SiteOfficeBroker[],
};

const OfficeInfo = ({ classes, office, site, compliance, brokers }: $Props) => {
  const hiddenOffices = get(site, "uiConfig.hiddenOffices", []);
  let broker;
  if (office) {
    if (site.siteOffices.length > 1) {
      return site.siteOffices.map((siteOffice) => {
        if (!(hiddenOffices && hiddenOffices.includes(siteOffice.id))) {
          const urlFriendlyAddress = encodeURIComponent(
            `${siteOffice.fullStreetAddress || ""} ${siteOffice.cityStateZip}`
          );
          if (
            compliance.officeOptions &&
            compliance.officeOptions.showFooterBrokers &&
            brokers &&
            brokers.length
          ) {
            // find the appropriate broker
            broker = find(brokers, { mlsId: office.mlsOfficeId });
          } else {
            broker = {
              fullName: siteOffice.brokerName,
              url: siteOffice.brokerUrl,
              title: siteOffice.brokerTitle,
              officePhone: siteOffice.brokerOfficePhone,
              cellPhone: siteOffice.brokerCellPhone,
              officePhoneFormatted: siteOffice.brokerOfficePhoneFormatted,
              cellPhoneFormatted: siteOffice.brokerCellPhoneFormatted,
            };
          }
          return (
            <div key={siteOffice.id} className={classes.root}>
              {siteOffice.logo ? (
                <div className={classes.logo}>
                  <img
                    src={siteOffice.logo}
                    alt={siteOffice.name || ""}
                    title={siteOffice.name || ""}
                  />
                </div>
              ) : null}
              {siteOffice.name ? (
                <div className={classes.subheading} type="heading6">
                  {siteOffice.name}
                </div>
              ) : null}
              {broker && <BrokerInfo broker={broker} />}
              {siteOffice.streetAddress1 ? (
                <a
                  href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {siteOffice.streetAddress1}
                </a>
              ) : null}
              {siteOffice.streetAddress2 ? (
                <div>
                  <a
                    href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {siteOffice.streetAddress2}
                  </a>
                </div>
              ) : null}
              {siteOffice.cityStateZip ? (
                <div>
                  <a
                    href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {siteOffice.cityStateZip}
                  </a>
                </div>
              ) : null}
              {siteOffice.officePhoneFormatted ? (
                <div>
                  <a
                    href={`tel:${siteOffice.officePhone}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {siteOffice.officePhoneFormatted}
                  </a>
                </div>
              ) : null}
              {siteOffice.email ? (
                <div>
                  <a
                    href={`mailto:${siteOffice.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {siteOffice.email}
                  </a>
                </div>
              ) : null}
              {broker && <BrokerUrl broker={broker} />}
              {siteOffice.url && (
                <div>
                  <a
                    href={`${siteOffice.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {siteOffice.url}
                  </a>
                </div>
              )}
              {siteOffice.socialMedia ? (
                <AgentSocial socialMedia={siteOffice.socialMedia} />
              ) : null}
            </div>
          );
        }
        return null;
      });
    } else {
      const urlFriendlyAddress = encodeURIComponent(
        `${office.fullStreetAddress || ""} ${office.cityStateZip}`
      );
      if (
        compliance.officeOptions &&
        compliance.officeOptions.showFooterBrokers &&
        brokers &&
        brokers.length
      ) {
        // find the appropriate broker
        broker = find(brokers, { mlsId: office.mlsOfficeId });
      } else {
        broker = {
          fullName: office.brokerName,
          url: office.brokerUrl,
          title: office.brokerTitle,
          officePhone: office.brokerOfficePhone,
          cellPhone: office.brokerCellPhone,
          officePhoneFormatted: office.brokerOfficePhoneFormatted,
          cellPhoneFormatted: office.brokerCellPhoneFormatted,
        };
      }
      return (
        <div className={classes.root}>
          {office.logo ? (
            <div className={classes.logo}>
              <img
                src={office.logo}
                alt={office.name || ""}
                title={office.name || ""}
              />
            </div>
          ) : null}
          {office.name ? (
            <div className={classes.subheading} type="heading6">
              {office.name}
            </div>
          ) : null}
          {broker && <BrokerInfo broker={broker} />}
          {office.streetAddress1 ? (
            <div>
              <a
                href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {office.streetAddress1}
              </a>
            </div>
          ) : null}
          {office.streetAddress2 ? (
            <div>
              <a
                href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {office.streetAddress2}
              </a>
            </div>
          ) : null}
          {office.cityStateZip ? (
            <div>
              <a
                href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {office.cityStateZip}
              </a>
            </div>
          ) : null}
          {office.officePhoneFormatted ? (
            <div>
              <a
                href={`tel:${office.officePhone}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {office.officePhoneFormatted}
              </a>
            </div>
          ) : null}
          {office.email ? (
            <div>
              <a
                href={`mailto:${office.email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {office.email}
              </a>
            </div>
          ) : null}
          {broker && <BrokerUrl broker={broker} />}
          {office.url && (
            <div>
              <a
                href={`${office.url}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {office.url}
              </a>
            </div>
          )}
          {office.socialMedia ? (
            <AgentSocial
              className={classes.officeSocial}
              socialMedia={office.socialMedia}
            />
          ) : null}
        </div>
      );
    }
  }
  return null;
};

const styles = (theme) => ({
  root: {
    "& p": {
      margin: "0",
      maxWidth: "none",
    },
  },
  subheading: {
    fontWeight: "700",
    color: "#fff !important",
  },
  text: {
    color: theme.colors.white,
    fontSize: "14px",
    lineHeight: "18px",
  },
  logo: {
    margin: "0 auto",
    width: "100%",
    maxWidth: "225px",
    "& img": {
      display: "block",
      margin: "0 auto",
      width: "100%",
      height: "auto",
    },
  },
  officeSocial: {
    marginTop: theme.spacing.unit * 0.75,
    justifyContent: "center",
    "& a": {
      color: "#fff !important",
    },
  },
});

export default withGlobalContext(withStyles(styles)(OfficeInfo));
